import { render } from "./GoodsIn.vue?vue&type=template&id=46b2f2b2&scoped=true"
import script from "./GoodsIn.vue?vue&type=script&lang=js"
export * from "./GoodsIn.vue?vue&type=script&lang=js"

import "./GoodsIn.vue?vue&type=style&index=0&id=46b2f2b2&scoped=true&lang=css"

import exportComponent from "/home/adrianhardy/projects/Clients/O/Orchard_Crown_Ltd/ionic-storeroom/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46b2f2b2"]])

export default __exports__